$(document).ready(function(){
	$('body').addClass('js');

  // -- home intro --
  if ($('.sectionType--intro').length) {
   $('.sectionType--intro .btn--close').on('click', function(){
      $('.sectionType--intro').slideUp(400, function(){
        $('.sectionType--activities').css({
          'border-top-width': 0
        });
      });
   });
  }

  // -- prevent right click on img --
  $('img').on('contextmenu',function(e){
    return false;
  });
  $('img').on('mousedown', function(e){
    e.preventDefault();
  });

});


$(window).on('resize orientationchange', function(){
  if ($(window).width() < 767) {
    $('body').addClass('mobile tablet');
  } else {
    $('body').removeClass('mobile tablet');
  }
});